import React from "react"

import AssistantHeaderButtonContent from "~components/outfitter-assistant/assistant-header-button-content"
import useIsOutfitterAssistantAvailable from "~utils/hooks/use-is-outfitter-assistant-available"

export default function AssistantHeaderButton() {
    const isAvailable = useIsOutfitterAssistantAvailable()

    if (!isAvailable) {
        return null
    }

    // Split into a separate component so we only subscribe to the
    // OutfitterAssistantProvider when the button is actually going to render.
    // This keeps non-admin pages (and tests without the provider) working.
    return <AssistantHeaderButtonContent />
}
